import { Component, Input } from "@angular/core";
import { KpiBaseChartDto } from "../../../../services/chart/kpi-chart.service";

@Component({
  selector: "users-summary-chart",
  styleUrls: ["users-summary-chart.component.scss"],
  standalone: false,
  template: `
    <div class="d-flex align-items-center">
      <strong>{{ "portal.charts.users.summary.title" | translate }}</strong>
    </div>

    <div class="row gx-0">
      <div class="col-sm-12 col-md-3 d-none d-md-block"></div>
      <div class="col-sm-12 col-md-4 text-center">
        <div class="text-center">
          <span class="fs-1"> {{ allUsers }} </span>
          <hr class="mt-0 gem-color-blue" style="border: 1px solid; opacity: 1!important" />
          <div>{{ "portal.charts.users.summary.labels.allUsers" | translate }}</div>
          <div class="d-block d-md-none">
            <div>
              {{ "portal.charts.users.summary.labels.internal" | translate }}
              <strong>{{ allInternalUsers }}</strong>
            </div>
            <div>
              {{ "portal.charts.users.summary.labels.external" | translate }}
              <strong>{{ allExternalUsers }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1 d-none d-md-block text-center">
        <div class="vr" style="height: 100%"></div>
      </div>
      <div class="d-block d-md-none">
        <hr />
      </div>
      <div class="col-sm-12 col-md-4 text-center">
        <div class="text-center">
          <span class="fs-1">{{ newUsers }}</span>
          <hr class="mt-0 gem-color-neon" style="border: 1px solid; opacity: 1!important" />
          <div>{{ "portal.charts.users.summary.labels.newUsers" | translate }}</div>
          <div class="d-block d-md-none">
            <div>
              {{ "portal.charts.users.summary.labels.internal" | translate }}
              <strong>{{ newInternalUsers }}</strong>
            </div>
            <div>
              {{ "portal.charts.users.summary.labels.external" | translate }}
              <strong>{{ newExternalUsers }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row gx-0">
      <div class="col-sm-12 col-md-3 d-none d-md-block">
        {{ "portal.charts.users.summary.labels.internal" | translate }}
      </div>
      <div class="col-sm-12 col-md-4 text-center  d-none d-md-block">
        <strong>{{ allInternalUsers }}</strong>
      </div>
      <div class="col-md-1 d-none d-md-block text-center">
        <div class="vr" style="height: 100%"></div>
      </div>
      <div class="col-sm-12 col-md-4 text-center  d-none d-md-block">
        <strong>{{ newInternalUsers }}</strong>
      </div>
    </div>

    <div class="row gx-0">
      <div class="col-sm-12 col-md-3 d-none d-md-block">
        {{ "portal.charts.users.summary.labels.external" | translate }}
      </div>
      <div class="col-sm-12 col-md-4 text-center  d-none d-md-block">
        <strong>{{ allExternalUsers }}</strong>
      </div>
      <div class="col-md-1 d-none d-md-block text-center">
        <div class="vr" style="height: 100%"></div>
      </div>
      <div class="col-sm-12 col-md-4 text-center  d-none d-md-block">
        <strong>{{ newExternalUsers }}</strong>
      </div>
    </div>
  `,
})
export class UsersSummaryChartComponent {
  title: string;
  allUsers: number = 0;
  newUsers: number = 0;
  newInternalUsers: number = 0;
  newExternalUsers: number = 0;
  allInternalUsers: number = 0;
  allExternalUsers: number = 0;

  @Input() set chart(chart: KpiBaseChartDto) {
    if (chart && chart.data) {
      this.title = chart.title;
      this.allUsers = 0;
      this.newUsers = 0;
      this.newInternalUsers = 0;
      this.newExternalUsers = 0;
      this.allInternalUsers = 0;
      this.allExternalUsers = 0;

      chart.data.forEach((d) => {
        switch (d.label) {
          case "internal_new": {
            this.newUsers = this.newUsers + d.value;
            this.newInternalUsers = d.value;
            break;
          }
          case "external_new": {
            this.newUsers = this.newUsers + d.value;
            this.newExternalUsers = d.value;
            break;
          }
          case "internal_all": {
            this.allUsers = this.allUsers + d.value;
            this.allInternalUsers = d.value;
            break;
          }
          case "external_all": {
            this.allUsers = this.allUsers + d.value;
            this.allExternalUsers = d.value;
            break;
          }
        }
      });
    }
  }

  // @Input() set data(data: KpiChartDataDto[]) {
  //   if (data) {
  //     this.allUsers = 0;
  //     this.newUsers = 0;
  //     this.newInternalUsers = 0;
  //     this.newExternalUsers = 0;
  //     this.allInternalUsers = 0;
  //     this.allExternalUsers = 0;

  //     data.forEach((d) => {
  //       switch (d.label) {
  //         case "internal_new": {
  //           this.newUsers = this.newUsers + d.value;
  //           this.newInternalUsers = d.value;
  //           break;
  //         }
  //         case "external_new": {
  //           this.newUsers = this.newUsers + d.value;
  //           this.newExternalUsers = d.value;
  //           break;
  //         }
  //         case "internal_all": {
  //           this.allUsers = this.allUsers + d.value;
  //           this.allInternalUsers = d.value;
  //           break;
  //         }
  //         case "external_all": {
  //           this.allUsers = this.allUsers + d.value;
  //           this.allExternalUsers = d.value;
  //           break;
  //         }
  //       }
  //     });
  //   }
  // }
  constructor() {}
}
